<template lang="pug">
  .products-index
    breadcrumb-nav(:items="nav($route.params.collection)")
    hostem-header-dropdown.z-20.fixed

    //- (filters mbl)
    template(v-if="mobileMenuActive")
      //- fixed btn
      mobile-bottom-menu.z-40
        button.pointer-events-auto.px-10.-ml-10(slot="right", @click="setMblFilters(true)", aria-label="Open Hostem Menu")
          .w-40.h-40.rounded-full.border.bg-gray-100.flex.items-center.justify-center(:class="filtersActive ? 'text-blue border-current' : 'text-black border-gray-300'")
            .icon-filters.border-t.border-b
      //- (filters overlay)
      transition(name="overlaymenu", @enter="lockScroll(true)", @before-leave="onMobileFiltersMenuLeave", @after-leave="closeMenuDropdowns")
        overlay-menu.fixed.text-black(v-show="mblFilters", @close="setMblFilters(false)", bg="bg-gray-100", :visible="mblFilters")
          aside.pt-100(:class="{'pb-100': !filtersActive}")
            product-filters-menu(ref="mobileMenu", :products="products", :filtersActive="filtersActive", @apply="onApplyFilters", @clear="queueScrollTop = true", @close="setMblFilters(false)")

    //-
    main-el.pt-100.md-pt-120
      transition(name="pagefade", @after-leave="$root.$emit('triggerScroll')")
        //- "keep alive" / cache pages: components with "Products" in name (results based pages)
        keep-alive(:include="/^Products/", :max="2")
          router-view(@products="products = $event", :key="$route.path", :filtersActive="filtersActive")

</template>

<script>
import { mapState, mapGetters, mapMutations } from 'vuex'
import ProductFiltersMenu from '@/components/Shop/ProductFiltersMenu'
import HostemHeaderDropdown from '@/components/Shop/HostemHeaderDropdown'
import IconChevron from '@/components/Icons/ChevronY'
export default {
  name: 'Products',
  computed: {
    ...mapGetters({ nav: 'shop/nav', winIs: 'winIs' }),
    ...mapState({
      mblFilters: state => state.shop.mblFilters
    }),
    filtersActive () {
      const rt = this.$route.query
      return rt.maker || rt.tag || rt.size || rt.colour || rt.gender
    },
    mobileMenuActive () {
      return !this.winIs('md')
    }
  },
  data () {
    return {
      products: [],
      queueScrollTop: false
    }
  },
  methods: {
    ...mapMutations({ lockScroll: 'lockScroll', setMblFilters: 'shop/setMblFilters' }),
    onMobileFiltersMenuLeave () {
      this.lockScroll(false)
      setTimeout(() => {
        if (this.queueScrollTop) window.scroll(0, 0)
        this.queueScrollTop = false
      }, 150)
    },
    onApplyFilters () {
      this.queueScrollTop = true
      this.setMblFilters(false)
    },
    closeMenuDropdowns () {
      const menu = this.$refs.mobileMenu
      if (menu) menu.closePrimaryDropdowns()
    }
  },
  watch: {
    '$route' (to, from) {
      // results were filtered on the current page
      if (to.path === from.path && to.fullPath !== from.fullPath) {
        // queye a scroll to top...
        this.queueScrollTop = true
      }
      // close mobile menu if path changed
      if (to.path !== from.path) {
        this.setMblFilters(false)
      }
    },
    mobileMenuActive (active) {
      if (!active) {
        this.lockScroll(false)
        this.setMblFilters(false)
      }
    }
  },
  destroyed () {
    this.setMblFilters(false)
  },
  components: { ProductFiltersMenu, IconChevron, HostemHeaderDropdown }
}
</script>

<style>
.icon-filters{
  position:relative;
  width:18px;
  height:6px;
  border-color:currentColor;
  &::before, &::after{
    content:'';
    display: block;
    width:2px; height:3px;
    position:absolute;
    background:currentColor;
  }
  &::before{
    top:-2px;
    right:4px;
  }
  &::after{
    bottom:-2px;
    left:4px;
  }
}
</style>
